import { transparentize } from 'polished';
import { colors } from '@ardoq/design-tokens';
import { createSvgElement } from '@ardoq/dom-utils';
import {
  ComponentGraphEdge,
  GraphEdge,
  isComponentGraphEdge,
} from '@ardoq/graph';
import { referenceInterface } from '@ardoq/reference-interface';
import {
  EdgeStyleBase,
  IEdge,
  IRenderContext,
  SvgVisual,
  Visual,
} from '@ardoq/yfiles';
import { SMOOTH_PATH_OPTIONS } from 'tabview/relationshipDiagrams/consts';
import { createPath } from 'yfilesExtensions/edgeUtil';
import type { Edge as OldGraphEdge } from 'graph/edge';
import { dataModelId } from 'tabview/graphComponent/graphComponentUtil';
import { REFERENCE_ID_ATTRIBUTE } from '@ardoq/global-consts';

class HoverEdgeStyle extends EdgeStyleBase {
  protected override createVisual(
    context: IRenderContext,
    edge: IEdge
  ): Visual | null {
    const graphEdge = edge.tag as GraphEdge | OldGraphEdge | ComponentGraphEdge;
    const modelId = dataModelId(graphEdge);

    const colorAttributes = isComponentGraphEdge(graphEdge)
      ? graphEdge.getCssColorAttributes()
      : referenceInterface.getCssColors(modelId, {
          useAsBackgroundStyle: false,
        });

    const { stroke = colors.black950 } = colorAttributes ?? {
      stroke: colors.black950,
    };

    const hoverPath = createPath(edge, true).createSmoothedPath(
      SMOOTH_PATH_OPTIONS
    );
    const pathData = hoverPath.createSvgPathData();

    const pathElement = createSvgElement('path', {
      d: pathData,
      fill: 'none',
      stroke: transparentize(0.7, stroke),
      'stroke-width': '16',
      [REFERENCE_ID_ATTRIBUTE]: modelId,
    });

    return new SvgVisual(pathElement);
  }
}
export { HoverEdgeStyle };
